import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API, getHeaders } from '../portalShared';

export default function Invoices() {
  const [invoices, setInvoices] = useState([]);
  useEffect(() => { axios.get(`${API}/portal/invoices`, { headers: getHeaders() }).then(r => setInvoices(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="portal-invoices">
      <h3 className="text-sm font-semibold mb-4">Invoices</h3>
      {invoices.length === 0 ? <p className="text-[#6B7280] text-sm">No invoices yet.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-white/10">
              {['Date','Description','Amount','Status'].map(h => <th key={h} className="text-left py-2 text-[#6B7280] font-mono text-[10px] uppercase">{h}</th>)}
            </tr></thead>
            <tbody>
              {invoices.map(inv => (
                <tr key={inv.id} className="border-b border-white/5">
                  <td className="py-2 text-[#6B7280] text-xs">{inv.date ? new Date(inv.date).toLocaleDateString() : '—'}</td>
                  <td className="py-2 text-white text-xs">{inv.description}</td>
                  <td className="py-2 font-mono text-xs text-[#FF4343]">${inv.amount?.toLocaleString()}</td>
                  <td className="py-2"><span className={`text-[10px] font-mono uppercase ${inv.status === 'succeeded' ? 'text-[#10B981]' : 'text-[#9CA3AF]'}`}>{inv.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}


